/* eslint-disable max-len */
define({
    ok: '确定',
    cancel: '取消',
    standardColors: '标准颜色',
    customColors: '自定义颜色',
    recentColors: '最近使用的颜色',
    preview: '预览',
    redTitle: 'R', // Used for label for three edit fields to enter [R, G, B] color
    greenTitle: 'G', // Used for label for three edit fields to enter [R, G, B] color
    blueTitle: 'B', // Used for label for three edit fields to enter [R, G, B] color
    hexTitle: '十六进制', // Used for label for to enter hex color
    hueTitle: 'H', // Used for label for three edit fields to enter [H, S, V] color
    saturationTitle: 'S', // Used for label for three edit fields to enter [H, S, V] color
    valueTitle: 'V', // Used for label for three edit fields to enter [H, S, V] color
    doubleLabel: 'RGB [0-1]',
    intLabel: 'RGB [0-255]',
    hexLabel: '十六进制',
    hsvLabel: 'HSV',
    auto: '自动',
    none: '无',
    flat: '单一着色',
    interp: '插补着色',
    texturemap: '纹理映射',
    invalidHexErrorMessage: '值必须为有效的十六进制格式。'
});
